import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Room } from './model/room.model';
import { ErrorCode } from '../../models/error-code.model';

export const RoomApiActions = createActionGroup({
    source: 'API/Room',
    events: {
        'load rooms': emptyProps(),
        'create room': props<{ room: Room }>()
    }
});

export const RoomActions = createActionGroup({
    source: 'Room',
    events: {
        'load rooms success': props<{ rooms: Room[] }>(),
        'load roooms failure': props<{ error: ErrorCode }>(),
        'create room success': props<{ room: Room }>(),
        'create room failure': props<{ error: ErrorCode }>()
    }
});
